import { getSubscriptions } from "./helpers";

/**
 * Get the last-updated subscription and display a CTA linking to it
 */
export default class VbcManageSubscriptionCta extends HTMLElement {
  get anchorEl() {
    return this.querySelector("a");
  }

  get digitalText() {
    return this.querySelector("[data-digital-text]");
  }

  get printText() {
    return this.querySelector("[data-print-text]");
  }

  async connectedCallback() {
    if (!this.anchorEl) return;

    try {
      const subscriptions = await getSubscriptions();

      if (!subscriptions?.length) return;

      // subscribers generally shouldn't have multiple subscriptions
      // but in case, match sorting to list order shown on overview page
      const sorted = subscriptions.toSorted(function (a, b) {
        return new Date(b.updated_at) - new Date(a.updated_at);
      });

      const subscription = sorted[0];

      const pathToSubscription = this.getSubscriptionRoute(subscription);
      this.anchorEl.setAttribute("href", pathToSubscription);

      const isDigital = subscription.product_title?.includes("Reader");

      if (isDigital) {
        this.digitalText.removeAttribute("hidden");
      } else {
        this.printText.removeAttribute("hidden");
      }

      this.anchorEl.removeAttribute("hidden");
    } catch (error) {
      // log the error but don't do anything user-facing; just keep the component hidden
      console.error(error);
    }
  }

  getSubscriptionRoute(subscription) {
    const route = new URL(window.location);
    const newPathname = route.pathname.replace(
      "/overview",
      `/subscriptions/${subscription.id}`,
    );

    return `${newPathname}${route.search}`;
  }
}
